import popupStore from '../store/popupStore'

export const alertPopup = ({ type, title, body }) => {
    if (['alert', 'error', 'success'].includes(type)) {
        popupStore.togglePopup(type, {body, title} )
    }
}